var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.1c-1.7 0-3 1.4-3 3.2v3.2h6V8.3c0-1.8-1.3-3.2-3-3.2zM12 3c2.8 0 5 2.4 5 5.3v3.2c1.1 0 2 .9 2 2.1v6.3c0 1.2-.9 2.1-2 2.1H7c-1.1 0-2-.9-2-2.1v-6.3c0-1.2.9-2.1 2-2.1V8.3C7 5.4 9.2 3 12 3z"
  })));
}

export default SvgPadlock;